<template>
  <v-layout row fill-height ma-0>
    <!--v-flex xs1>
        {{label}}
    </v-flex-->
    <v-col cols="12" sm="6" md="4" class="pa-0 ma-0 pr-1">
      <template v-if="readOnly">
        {{ $t("globals.term") }}
        <br />
        <span class="minfo">
          {{ $t("enums." + value.TimeUnit) }}
        </span>
      </template>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-container pa-0>
            <v-row no-gutters>
              <v-col>
                <trans-enum
                  :value.sync="value.TimeUnit"
                  :items="options.Enums.TermTimeUnit"
                  :label="
                    termLabel ? termLabel : $t('globals.term')
                  "
                  :rules="rules"
                  :disabled="disabled"
                ></trans-enum>
              </v-col>
              <v-col style="margin-top:20px;margin-left:3px" cols="auto">
                <v-icon v-bind="attrs" v-on="on">help</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <span>{{ timeunitTooltip }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pa-0 ma-0 pr-1">
      <template v-if="readOnly">
        {{ frequencyLabel
                      ? frequencyLabel
                      : $t('components.periodpicker.term_frequency') }}
        <br />
        <span class="minfo">
          {{ value.Frequency }}
        </span>
      </template>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-container pa-0>
            <v-row no-gutters>
              <v-col>
                <no-autocomplete-textfield
                  :label="
                    frequencyLabel
                      ? frequencyLabel
                      : $t('components.periodpicker.term_frequency')
                  "
                  v-model="value.Frequency"
                  :rules="
                    rules ? rules.concat([$rules.integer]) : [$rules.integer]
                  "
                  :disabled="disabled"
                ></no-autocomplete-textfield>
              </v-col>
              <v-col style="margin-top:20px;margin-left:3px" cols="auto">
                <v-icon v-bind="attrs" v-on="on">help</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <span>{{ frequencyTooltip }}</span>
      </v-tooltip>
    </v-col>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransEnum from "@/components/TransEnum.vue";
export default {
  name: "period-picker",
  props: [
    "value",
    "label",
    "rules",
    "disabled",
    "frequencyTooltip",
    "timeunitTooltip",
    "termLabel",
    "frequencyLabel",
    "readOnly"
  ],
  components: {
    TransEnum,
    NoAutocompleteTextfield,
  },
  mounted() {
    console.log(
      "period picker mounted-----------------------------------------------",
      this.options.Enums.TermTimeUnit,
      this.value
    );
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {},
  methods: {
    filterFunc(item, search) {
      console.log(item);
      return (
        this.$t("enums." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
  },
};
</script>

<style>
.no-padding {
  padding: 0px !important;
}
</style>
<style scoped>
  .minfo {
    font-weight: bold;
    color: #222;
  }
  </style>
